export function SmallArrow({ ...rest }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 23.064 11.065"
      {...rest}
    >
      <title>Pfeil</title>
      <g id="Pfeil" transform="translate(0 0.53)">
        <g
          id="Gruppe_2963"
          data-name="Gruppe 2963"
          transform="translate(15303.5 29.441)"
        >
          <line
            id="Linie_24"
            data-name="Linie 24"
            x2="22"
            transform="translate(-15303.5 -24.439)"
            fill="none"
            strokeMiterlimit="10"
            strokeWidth="1.5"
            className="stroke-current"
          />
          <path
            id="Pfad_2312"
            data-name="Pfad 2312"
            d="M1451.645,3315.879l5,5-5,5"
            transform="translate(-16738.145 -3345.32)"
            fill="none"
            strokeMiterlimit="10"
            strokeWidth="1.5"
            className="stroke-current"
          />
        </g>
      </g>
    </svg>
  )
}

export function LargeArrow({ ...rest }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 67.445 24.444"
      {...rest}
    >
      <title>Pfeil</title>
      <g
        id="Gruppe_2379"
        data-name="Gruppe 2379"
        transform="translate(-188 -1352.766)"
      >
        <g
          id="dark_arrow_right"
          data-name="dark arrow right"
          transform="translate(242 1352.979)"
        >
          <path
            id="Pfad_1558"
            data-name="Pfad 1558"
            d="M20443.32,3667.257l12,11.5-12,11.5"
            transform="translate(-20443.32 -3666.747)"
            fill="none"
            strokeWidth="2"
            className="stroke-current"
          />
        </g>
        <rect
          id="Rechteck_1783"
          data-name="Rechteck 1783"
          width="66"
          height="2"
          transform="translate(188 1364)"
          className="fill-current"
        />
        <path
          id="Pfad_2971"
          data-name="Pfad 2971"
          d="M0,0H66"
          transform="translate(188 1364.988)"
          fill="none"
          strokeWidth="2"
          className="stroke-current"
        />
      </g>
    </svg>
  )
}

export function LongScribbledArrow({ ...rest }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 933 118"
      xmlns="http://www.w3.org/2000/svg"
      width="6em"
      {...rest}
    >
      <title>Pfeil</title>
      <path d="M256.225 77.955C274.117 76.2894 291.95 78.8251 309.817 80.0002C322.153 80.8035 334.66 79.6237 346.904 77.3281C357.467 75.3493 368.061 76.5902 378.58 74.8922C389.436 73.1388 400.343 72.0346 411.225 70.6208C413.404 70.336 415.567 69.9017 417.745 69.5669C427.894 67.9948 438.153 68.9411 448.316 66.9187C453.285 65.9293 458.487 66.2662 463.585 68.0551C466.367 69.0309 469.465 69.1518 472.299 68.5065C486.094 65.356 500.007 67.7239 513.847 66.923C516.4 66.7722 518.97 67.2414 521.525 67.1706C544.917 66.4973 568.242 70.0159 591.6 70.7733C605.13 71.2075 618.828 72.8892 632.161 70.6662C649.22 67.8237 666.436 69.149 683.411 65.4177C689.148 64.156 695.085 64.8014 700.91 64.1784C731.891 60.8637 762.971 62.3979 793.986 61.153C809.655 60.5229 825.359 60.3626 841.019 59.1626C857.043 57.9368 873.086 56.9906 889.11 55.7547C896.382 55.1986 903.65 54.3126 910.903 53.4067C912.304 53.2344 913.78 52.4709 914.204 49.9938C914.608 47.617 913.73 45.8106 912.681 44.3172C910.569 41.3205 908.409 38.3845 906.181 35.5897C900.878 28.9234 895.508 22.3681 890.206 15.7019C889.095 14.2994 888.072 12.7156 887.126 11.0605C885.508 8.21594 885.272 3.58934 886.642 2.30732C888.697 0.374298 891.025 0.627044 892.805 2.5689C896.335 6.42307 899.62 10.7714 902.932 15.0491C911.757 26.4597 920.391 38.1933 929.859 48.5036C933.81 52.8011 933.864 55.7105 930.898 62.1587C921.46 82.7219 908.941 99.0439 896.702 115.721C894.215 119.121 890.889 117.974 889.298 113.709C887.999 110.24 888.945 107.404 890.606 105.067C896.128 97.3281 901.729 89.7078 907.308 82.0678C908.105 80.975 909.032 80.0898 909.836 79.0169C911.466 76.8506 913.213 74.5426 912.593 70.902C911.873 66.683 909.228 67.2753 907.207 67.3176C897.71 67.5291 888.123 66.9817 878.757 68.7214C871.476 70.0777 864.132 70.9351 856.945 70.6897C841.18 70.1512 825.725 74.9186 809.97 74.1198C794.616 73.3447 779.242 73.9901 763.881 73.6251C740.849 73.0825 717.911 74.4586 695.07 78.3935C693.627 78.6465 692.143 78.45 690.684 78.5533C672.836 79.8782 654.925 80.3843 637.159 82.8781C626.923 84.3115 616.747 84.6136 606.547 84.2763C590.122 83.7383 573.707 82.4702 557.289 81.492C556.924 81.4678 556.57 81.2835 556.204 81.2593C542.349 80.2902 528.493 78.7609 514.636 78.532C502.977 78.338 491.325 79.854 479.662 80.2601C466.153 80.7257 452.633 81.3917 439.123 80.8772C427.341 80.4351 415.822 82.7994 404.248 84.8443C391.589 87.0765 378.938 89.3486 366.135 89.1629C356.632 89.0245 347.213 90.5946 337.763 91.5055C318.841 93.3176 299.806 95.0617 280.837 90.8438C276.44 89.8638 272.011 89.0445 267.738 90.1328C251.773 94.178 235.656 91.7948 219.614 92.3808C214.134 92.5783 208.638 92.3161 203.154 92.3036C194.033 92.2891 184.98 92.5433 175.875 94.4188C164.362 96.7827 152.626 96.9701 141.006 98.3257C127.942 99.8443 114.89 101.623 101.835 103.281C100.013 103.51 98.195 103.96 96.3759 103.929C81.4095 103.687 66.4367 103.486 51.4658 102.965C47.4754 102.828 43.4937 101.032 39.5122 101.005C31.1346 100.939 22.7151 99.573 14.3916 102.456C11.2494 103.546 7.86324 103.42 4.58364 103.383C2.1397 103.352 0.504131 101.198 0.129057 97.4931C-0.187626 94.3678 1.02708 92.5883 2.81134 91.3197C5.83823 89.1611 9.09849 88.4288 12.3921 88.4662C24.4571 88.6038 36.5173 88.8915 48.5856 89.239C67.9596 89.8 87.3511 91.0111 106.69 88.9023C120.855 87.3561 134.961 84.2806 149.141 83.6642C164.107 83.0054 178.993 80.8076 193.898 79.4096C214.714 77.4572 235.495 80.006 256.225 77.955Z" />
    </svg>
  )
}

export function ScribbledArrow({ ...rest }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 184 88"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...rest}
    >
      <title>Pfeil</title>
      <path
        d="M106.876 52.11c-16.578-.276-33.21.21-49.724-1.044-15.72-1.194-31.428-1.205-47.142-1.763-2.815-.1-5.629-.26-8.2-1.664C.756 47.064 0 46.119 0 44.859c0-1.238.66-2.332 1.707-2.88.972-.508 2.08-.906 3.15-.978 1.388-.094 2.814.072 4.197.315 13.931 2.454 28.046 1.116 42.048 2.156 7 .52 14.06.121 21.05.735 28.858 2.52 57.79 1.674 86.685 2.531 2.512.077 5.051-.1 7.546-.409.66-.083 1.524-1.006 1.724-1.719.183-.657-.179-1.818-.692-2.294-2.739-2.547-5.629-4.902-8.394-7.416a42.739 42.739 0 0 1-4.198-4.361c-1.474-1.78-1.188-3.576.703-5.422 1.145-1.117 2.69-1.697 3.689-.282 5.321 7.56 13.143 11.916 19.884 17.648 1.097.928 2.247 1.796 3.274 2.802 2.209 2.166 2.166 4.642-.114 6.908-.815.813-1.755 1.487-2.663 2.183-6.822 5.218-14.217 9.634-20.197 16.045-.562.602-1.421.928-2.188 1.277-1.496.69-2.777.143-3.727-1.09-.773-1-.697-2.265-.13-3.354 1.41-2.692 3.873-4.228 6.072-6.074 1.82-1.52 5.196-2.415 4.051-5.71-.918-2.63-3.884-1.834-6.039-1.895-12.365-.343-24.73-.603-37.095-.873-4.489-.1-8.983-.155-13.472-.227 0-.11 0-.238.005-.365z"
        fill="currentColor"
      />
    </svg>
  )
}

export function VariantScribbledArrow({
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 184 88"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...rest}
    >
      <title>Pfeil</title>
      <path
        d="M79.874 47.207c14.088.05 29.316.523 44.524.015 11.037-.368 22.107-1.031 33.077-2.944 1.929-.334 3.891-.373 5.828-.647 1.72-.24 3.448-.484 5.13-.962 2.004-.573 2.45-2.247 1.102-4.015-3.139-4.11-6.888-7.343-10.544-10.69-1.925-1.759-3.882-3.447-5.381-5.799-.739-1.16-1.065-2.416-.167-3.591.918-1.2 2.045-2.053 3.465-1.276.584.32 1.173.733 1.64 1.26 5.994 6.8 13.024 11.598 20.413 15.558 2.546 1.365 3.824 3.198 4.103 6.451.138 1.584.522 3.133.768 4.707.497 3.209-.004 4.23-2.951 4.439-2.325.164-4.183 1.1-5.852 2.994-5.293 5.992-11.881 9.913-17.036 16.135-.301.364-.722.588-1.106.827-1.157.722-2.768.219-3.465-1.086-.664-1.24-.714-2.546.033-3.721.522-.827 1.136-1.624 1.829-2.212 2.684-2.276 5.426-4.433 8.123-6.69 1.424-1.19 3.106-2.072 3.861-4.17.263-.727.188-1.559-.605-1.888-1.49-.617-2.972-.313-4.492-.07-5.38.867-10.757 1.933-16.163 2.322-9.05.652-18.121.961-27.183 1.185-5.435.135-10.874-.298-16.31-.239-7.138.085-14.263.055-21.401-.383-6.947-.429-13.918-.523-20.877-.423-11.9.174-23.814.293-35.694 1.08-5.845.389-11.676 1.211-17.545 1.067-1.086-.03-2.175-.09-3.26-.095C2.117 54.34.64 53.897.063 51.8c-.426-1.559 1.344-3.93 3.18-4.353.848-.195 1.73-.195 2.593-.21 5.214-.095 10.432-.105 15.646-.259 8.891-.264 17.783-.707 26.674-.901 5.201-.115 10.41.005 15.616.189 4.984.18 9.973.573 16.1.941z"
        fill="currentColor"
      />
    </svg>
  )
}
